export default "<div *ngIf=\"screenStructure\">\n    <app-list [screenDescriptor]=\"screenStructure\" [screenHandler]=\"screenHandler\"></app-list>\n</div>";